module.exports = __webpack_public_path__ + "img/teaser_traktor8.2ede17db.jpg";